{
  "production":"Producción",
  "delay":"Demora",
  "gantt":"Gantt",
  "profile":"Perfil",
  "search":"Buscar",
  "inUser":"En uso",
  "idle":"Inativo",
  "down":"Apagado",
  "logout":"Cerrar sesión",
  "email":"Correo electrónico",
  "password":"Contraseña",
  "rememberMe":"Recuérdame",
  "signIn":"Iniciar sesión",
  "alarms":"Alarmas",
  "factoryDay":"Día fábrica",
  "shift":"Turno",
  "crew":"Equipo",
  "from":"Desde",
  "to":"Hasta",
  "range":"Intervalo",
  "filterType":"Tipo de filtro",
  "filter":"Filtro",
  "all":"Todo",
  "currentWeek":"Semana actual",
  "lastWeek":"Semana anterior",
  "last7Days":"Últimos 7 días",
  "currentMonth":"Mes actual",
  "lastMonth":"Mes anterior",
  "last30Days":"Últimos 30 días",
  "realTime": "Tiempo real",
  "session": "Sesiones",
  "machine": "Máquina",
  "update": "Actualizar",
  "month_1": "Enero",
  "month_2": "Febrero",
  "month_3": "Marzo",
  "month_4": "Abril",
  "month_5": "Mayo",
  "month_6": "Junio",
  "month_7": "Julio",
  "month_8": "Agosto",
  "month_9": "Septiembre",
  "month_10": "Octubre",
  "month_11": "Noviembre",
  "month_12": "Diciembre"
}
